export function date(value: string | number | Date) {
  const date = value instanceof Date ? value : new Date(value);
  return `${date.getMonth()}/${date.getDate()}/${date.getFullYear()}`;
}